import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, computed, toRefs } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "MortgageSelector",
  props: {
    mortgage: {
      type: String,
      required: true
    },
    disabledMortgages: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      disabledMortgages
    } = toRefs(props);
    const isMortgageDisabled = mortgageKey => {
      var _context;
      return _includesInstanceProperty(_context = disabledMortgages.value).call(_context, mortgageKey);
    };
    const changeMortgage = mortgageKey => {
      emit("update:mortgage", mortgageKey);
    };
    const mortgageTypeData = computed(() => [{
      label: t("direct-to-lender.fees.firstMortgage"),
      key: "first",
      disabled: isMortgageDisabled("first")
    }, {
      label: t("direct-to-lender.fees.secondMortgage"),
      key: "second",
      disabled: isMortgageDisabled("second")
    }, {
      label: t("direct-to-lender.fees.thirdMortgage"),
      key: "third",
      disabled: isMortgageDisabled("third")
    }]);
    return {
      mortgageTypeData,
      changeMortgage
    };
  }
});